var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33334 4.50004C4.33334 5.23641 4.93031 5.83337 5.66668 5.83337C6.40304 5.83337 7.00001 5.23641 7.00001 4.50004M4.33334 4.50004C4.33334 3.76366 4.93031 3.16671 5.66668 3.16671C6.40304 3.16671 7.00001 3.76366 7.00001 4.50004M4.33334 4.50004H1.33334M7.00001 4.50004H14.6667M10.3333 8.50004C10.3333 9.23641 10.9303 9.83337 11.6667 9.83337C12.403 9.83337 13 9.23641 13 8.50004M10.3333 8.50004C10.3333 7.76367 10.9303 7.16671 11.6667 7.16671C12.403 7.16671 13 7.76367 13 8.50004M10.3333 8.50004H1.33334M13 8.50004H14.6667M4.33334 12.5C4.33334 13.2364 4.93031 13.8334 5.66668 13.8334C6.40304 13.8334 7.00001 13.2364 7.00001 12.5M4.33334 12.5C4.33334 11.7637 4.93031 11.1667 5.66668 11.1667C6.40304 11.1667 7.00001 11.7637 7.00001 12.5M4.33334 12.5H1.33334M7.00001 12.5H14.6667M1.33334 1.83337V15.1667",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.1853484f12c408536de915cb216b9416.svg";
export { ForwardRef as ReactComponent };